import { render, staticRenderFns } from "./stationBaseInfo.vue?vue&type=template&id=045912a0&"
import script from "./stationBaseInfo.vue?vue&type=script&lang=js&"
export * from "./stationBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./stationBaseInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('045912a0')) {
      api.createRecord('045912a0', component.options)
    } else {
      api.reload('045912a0', component.options)
    }
    module.hot.accept("./stationBaseInfo.vue?vue&type=template&id=045912a0&", function () {
      api.rerender('045912a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/stationManage/stationBaseInfo/stationBaseInfo.vue"
export default component.exports